<template>
    <div class="animated fadeIn tender-step3">        
        <b-card>
            <div slot="header">
                Tendering Proces - Step 3 of 4  (Supplier/vendor Quotation received)
                <div class="card-header-actions">
                <button   class="btn btn-primary mr-1" @click="backStep()"><i class="fa fa-backward"></i> Prev.Step</button>
                <button   class="btn btn-primary mr-1" @click="nextStep()"><i class="fa fa-forward"></i> Next Step</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Tendering Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" disabled></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Tendering Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date"  disabled></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-input-group >
                        <b-input-group-prepend><label>Note/Description</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian"  placeholder="Note/Description" disabled></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>
              <b-card no-body v-show="(showList==true)" class="mt-1">
                    <b-table
                        class="mb-0"
                        ref="tblquotations"
                        outlined
                        striped hover small
                        style="font-size:smaller;"
                        :items="quotations.items"
                        :fields="quotations.fields"
                        :current-page="quotations.page"
                        :per-page="quotations.limit"
                        @row-clicked="rowClicked" 
                        >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(tglQuot)="data">
                            <span v-if="(data.item.tglQuot)">{{ data.item.tglQuot | moment("DD MMM YYYY") }}</span>
                        </template>
                        <template v-slot:cell(vendor_phone)="data">
                            <span v-if="(data.item.vendor_phone)">P.{{data.item.vendor_phone}}</span>&nbsp;
                            <span v-if="(data.item.vendor_fax)">F.{{data.item.vendor_fax}}</span>
                        </template>
                        <template v-slot:cell(action)="data">
                            <b-button-group size="sm">
                                <b-button variant="info" @click.stop="printRfq(data.item)"><i class="fa fa-print"></i> RFQ</b-button>
                                <b-button variant="warning" @click.stop="emailRfq(data.item)"><i class="fa fa-envelope"></i> RFQ</b-button>
                                <b-button variant="success" @click.stop="editQuotation(data.item)"><i class="fa fa-pencil"></i> Quotation Reply </b-button>
                            </b-button-group>                                
                        </template>
                    </b-table>
                    <b-row class="ml-1 mr-1 mb-0">
                        <b-col cols="5">
                            <b-row>
                            <div class="ml-2">
                                Showing {{(quotations.page - 1) * quotations.limit + 1}}
                                to <span v-if="((quotations.page * quotations.limit)>quotations.total)">{{quotations.total}}</span> <span v-else>{{quotations.page * quotations.limit}}</span>
                                of {{quotations.total}} entries
                            </div>    
                            </b-row>                    
                        </b-col>
                        <b-col cols="2">
                                <b-input-group>
                                    <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                    <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="quotations.limit"  style="width:80px;"/>
                                </b-input-group>
                        </b-col>
                        <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="quotations.total"
                            :per-page="quotations.limit"
                            v-model="quotations.page"
                        ></b-pagination>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card v-if="(showList==false)"  class="mt-2" header-bg-variant="primary" border-variant="primary">
                    <div slot="header" >Edit/input Supplier/Vendor Quotation 
                        <div class="card-header-actions">
                            <button  v-if="saveEnabled" class="btn btn-info mr-1" @click.stop="saveQuotation()"><i class="fa fa-save"></i> Save</button>
                            <button class="btn btn-info mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</button>
                        </div>
                    </div>
                    <b-input-group >
                        <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                        <b-form-input readonly v-model="quotationsObj.vendorinfo" :state="!$v.quotationsObj.vendorinfo.$error"></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col md="4" lg="4">
                        <b-input-group>
                            <b-input-group-prepend><label>Quotation Number</label></b-input-group-prepend>
                            <b-form-input v-model="quotationsObj.NoQuot" :state="!$v.quotationsObj.NoQuot.$error"></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="3" lg="3">
                        <b-input-group>
                            <b-input-group-prepend><span class="mt-1">Quot Version#</span></b-input-group-prepend>
                            <b-form-input v-model="quotationsObj.NoReply" type="number" :state="!$v.quotationsObj.NoReply.$error" v-bind:min="0"></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="5" lg="4">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Quotation Date</label></b-input-group-prepend>
                            <b-form-input v-model="quotationsObj.tglQuot" type="date"  :state="!$v.quotationsObj.tglQuot.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-row>
                        <b-col lg="3"  >  
                            <b-input-group >                          
                                <b-input-group-prepend><label>Currency </label></b-input-group-prepend>
                                <b-form-select @click.stop v-model="quotationsObj.matauang" :plain="true" :options="currency" :state="!$v.quotationsObj.matauang.$error"></b-form-select>
                            </b-input-group >
                        </b-col>
                        <b-col lg="5">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Exch. Rate</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{quotationsObj.matauang}}</span></b-input-group-prepend>
                                <b-input-group-prepend><span class="pl-2 pt-2 pr-2" >to</span></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text pl-3" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                <b-form-input v-model="quotationsObj.kurs" type="number" v-on:min='1' :state="!$v.quotationsObj.kurs.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col lg="10"  xl="10">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                <b-form-input v-model="quotationsObj.NoteQuot"  placeholder="Note/Remark" ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >  

                    <b-card no-body class="mt-2 mb-0">
                        <b-table
                            class="mb-0"
                            ref="tblOrdLines"
                            outlined
                            striped hover small
                            style="font-size:smaller;"
                            :items="quotLines.items"
                            :fields="quotLines.fields"
                            :current-page="quotLines.page"
                            :per-page="quotLines.limit"
                            >
                                <template v-slot:cell(index)="data">
                                {{data.index + 1}}
                                </template>
                                <template v-slot:cell(itemname)="data">
                                    {{data.item.partnumber}} 
                                    | {{data.item.itemname}}
                                </template>
                                <template v-slot:cell(qtyReady)="data">
                                    <span v-if="(data.item.qtyReady)">{{data.item.qtyReady}} {{data.item.unitsize}}</span>
                                </template>
                                <template v-slot:cell(qtyIndent)="data">
                                    <span v-if="(data.item.qtyIndent)"> {{data.item.qtyIndent}} {{data.item.unitsize}}</span>                                
                                </template>
                                <template v-slot:cell(LamaHari)="data">
                                    <span v-if="(data.item.LamaHari)">Ready Stock :{{data.item.LamaHari}} Days</span>
                                    <span v-if="(data.item.LamaIndent)">Indent :{{data.item.LamaIndent}} Days</span>
                                </template>
                                <template v-slot:cell(Price)="data">
                                {{data.item.Price|numFormat}}
                                </template>
                                <template v-slot:cell(diskon)="data">
                                {{(data.item.diskon) |numFormat}}
                                </template>
                                <template v-slot:cell(othercost)="data">
                                {{data.item.othercost|numFormat}}
                                </template>
                                <template v-slot:cell(KenaPPN)="data">
                                    <span v-if="(data.item.KenaPPN)">Yes</span>
                                </template>
                                <template v-slot:cell(Term)="data">
                                    <span v-if="(data.item.TermDP)">{{(data.item.TermDP) |numFormat}}</span>
                                    <span v-if="(data.item.Term)">Due :{{data.item.Term}} Days</span>
                                </template>
                                <template v-slot:cell(Warranty)="data">
                                    <span v-if="(data.item.Warranty)">{{data.item.Warranty}} Days</span>&nbsp; {{data.item.WarrantyTxt}}
                                </template>
                                <template v-slot:cell(action)="data">
                                    <div class="text-center">
                                    <a href="javascript:void(0)" @click="editOrdLines(data.item,data.toggleDetails)">
                                        <i class="fa fa-pencil"></i>
                                    </a>
                                    |
                                    <a href="javascript:void(0)" class="text-danger" @click="delOrdLines(data.index)">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                    </div>
                                </template>
                            <template v-slot:row-details="row">
                                <b-card class="row-details-form">
                                    <b-row>
                                        <b-col lg="6">
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Master Item</label></b-input-group-prepend>
                                                    <b-form-input readonly v-model="quotLinesObj.iteminfo" disabled style="width:50% !important;" ></b-form-input>
                                                    <b-input-group-prepend>
                                                    <span class="p-2">Qty Request</span>
                                                    </b-input-group-prepend>
                                                    <my-number class="form-control text-right" v-model="quotLinesObj.QtyRequest" :precision="2" disabled></my-number>
                                                    <b-form-input v-model="quotLinesObj.unitsize" disabled ></b-form-input>                                                    
                                                </b-input-group>
                                            <b-input-group>
                                                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                                <b-form-input v-model="quotLinesObj.spekdetail" disabled></b-form-input> 
                                            </b-input-group>
                                            <b-form-row>
                                            <b-col md="8">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label>Qty Ready Stock</label></b-input-group-prepend>
                                                    <b-form-input v-model="quotLinesObj.qtyReady" @change="calcPrice()" type="number" v-bind:min="0" :state="!$v.quotLinesObj.qtySupply.$error" ></b-form-input>
                                                    <b-input-group-append><label class="mt-2 pl-2 pr-2">Qty Indent</label></b-input-group-append>
                                                    <b-form-input v-model="quotLinesObj.qtyIndent" @change="calcPrice()" type="number" v-bind:min="0"  ></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col md="2">                            
                                                    <b-form-input v-model="quotLinesObj.unitsize" disabled ></b-form-input>
                                            </b-col>
                                            </b-form-row >     
                                            <b-form-row>
                                            <b-col md="10">                            
                                                <b-input-group>
                                                    <b-input-group-prepend><label >Delivery Time</label></b-input-group-prepend>
                                                    <b-input-group-append><label class="mt-1 pl-2 pr-2">: items Ready Stock</label></b-input-group-append>
                                                    <b-form-input v-model="quotLinesObj.LamaHari" type="number" v-bind:min="0" ></b-form-input>
                                                    <b-input-group-append><span class="input-group-text">Days</span></b-input-group-append>
                                                    <b-input-group-append><label class="mt-2 pl-3 pr-2">, items Indent</label></b-input-group-append>
                                                    <b-form-input v-model="quotLinesObj.LamaIndent"  type="number" v-bind:min="0" ></b-form-input>
                                                     <b-input-group-append><span class="input-group-text">Days</span></b-input-group-append>
                                                </b-input-group>
                                            </b-col>
                                            </b-form-row >     
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-row>
                                                <b-col md="7">                            
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>Unit price</label></b-input-group-prepend>
                                                        <b-input-group-prepend>
                                                        <span class="input-group-text">{{quotationsObj.matauang}}</span>
                                                        </b-input-group-prepend>
                                                        <my-number class="form-control text-right" v-model="quotLinesObj.Price" :precision="2" :state="!$v.quotLinesObj.Price.$error" @input="calcPrice()"></my-number>
                                                    </b-input-group>
                                                </b-col>
                                                <b-col md="5">  
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                                                        <b-input-group-prepend>
                                                        <span class="input-group-text" style="width:60px;">{{quotationsObj.matauang}}</span>
                                                        </b-input-group-prepend>
                                                        <my-number class="form-control text-right" v-model="quotLinesObj.diskon" :precision="2" ></my-number>
                                                    </b-input-group>
                                                </b-col>
                                            </b-form-row> 
                                            <b-form-row>
                                                <b-col md="7">                            
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>Other Cost</label></b-input-group-prepend>
                                                        <b-input-group-prepend>
                                                        <span class="input-group-text">{{quotationsObj.matauang}}</span>
                                                        </b-input-group-prepend>
                                                        <my-number class="form-control text-right" v-model="quotLinesObj.othercost" :precision="2"></my-number>
                                                    </b-input-group>
                                                </b-col>
                                                <b-col md="5">
                                                    <b-input-group>
                                                        <!-- <b-input-group-prepend><label>VAT (PPN) &nbsp;&nbsp;</label></b-input-group-prepend>
                                                        <b-form-radio-group inline  v-model="quotLinesObj.KenaPPN"  class="mt-1">
                                                            <b-form-radio :value="1">Yes</b-form-radio>
                                                            <b-form-radio :value="0">No</b-form-radio>
                                                        </b-form-radio-group> -->
                                                        <b-input-group-prepend v-if="(quotLinesObj.KenaPPN == 0)"><label>&nbsp;&nbsp;</label></b-input-group-prepend>
                                                       <b-form-checkbox id="chkPPN" class="ml-1 mt-2" v-model="quotLinesObj.KenaPPN" value=1 unchecked-value=0>VAT(PPN)</b-form-checkbox>
                                                        <b-input-group-prepend v-if="(quotLinesObj.KenaPPN == 1)"><span  class="pl-3 pt-2 pr-2 text-bold">Tarif</span></b-input-group-prepend>
                                                        <b-form-input v-if="(quotLinesObj.KenaPPN == 1)" v-model="quotLinesObj.ppn" type="number" ></b-form-input>
                                                        <b-input-group-append v-if="(quotLinesObj.KenaPPN == 1)"> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>

                                                    </b-input-group>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-row>
                                                <b-col md="5">
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>Term Payment Due </label></b-input-group-prepend>
                                                        <b-form-input v-model="quotLinesObj.TermText" ></b-form-input>
                                                        <!-- <b-form-input v-model="quotLinesObj.Term" type="number" v-bind:min="0" ></b-form-input>
                                                        <b-input-group-append><span class="input-group-text">Days</span></b-input-group-append> -->
                                                    </b-input-group>                            
                                                </b-col>
                                                <b-col md="7">
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>DP before Delivery</label></b-input-group-prepend>
                                                        <b-input-group-prepend>
                                                        <span class="input-group-text" style="width:60px;">{{quotationsObj.matauang}}</span>
                                                        </b-input-group-prepend>
                                                        <my-number class="form-control text-right" v-model="quotLinesObj.TermDP" :precision="2"  ></my-number>
                                                    </b-input-group>                            
                                                </b-col>
                                            </b-form-row>                      
                                            <b-form-row>
                                                <b-col md="5">
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>Warranty</label></b-input-group-prepend>
                                                        <b-form-input v-model="quotLinesObj.Warranty" type="number" v-bind:min="0" ></b-form-input>
                                                        <b-input-group-append><span class="input-group-text">Days</span></b-input-group-append>
                                                    </b-input-group>                            
                                                </b-col>
                                                <b-col md="7">
                                                    <b-input-group>
                                                        <b-input-group-prepend><label>Warranty Desc/Note </label></b-input-group-prepend>
                                                        <b-form-input v-model="quotLinesObj.WarrantyTxt" ></b-form-input>
                                                    </b-input-group>                            
                                                </b-col>
                                            </b-form-row>                      
                                        </b-col>
                                    </b-row>
                                            <b-row class="justify-content-center mt-1">
                                                <b-button v-if="saveEnabled" class="btn btn-success mr-1" @click.stop="saveOrdLines()">Update</b-button>
                                                <b-button class="btn btn-warning ml-1" @click.stop="row.toggleDetails">Cancel</b-button>
                                            </b-row>

                                </b-card>
                            </template>                        
                        </b-table>
                        <b-form-row>
                            <b-col cols="6">
                                <div class="ml-2">
                                    Showing
                                    {{(quotLines.page - 1) * quotLines.limit + 1}}
                                    to
                                    {{quotLines.page * quotLines.limit}}
                                    of
                                    {{quotLines.total}}
                                    entries
                                </div>    
                            </b-col>
                            <b-col cols="6">
                            <b-pagination
                                align="right"
                                :total-rows="quotLines.total"
                                :per-page="quotLines.limit"
                                v-model="quotLines.page"
                            ></b-pagination>
                            </b-col>
                        </b-form-row>
                    </b-card>    
                </b-card>                      
        </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

    </div>
</template>

<style lang="scss">
  .tender-step3 {
    .tbl-wrap {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }

  }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import proctender from "../../apis/proctender";
import { validationMixin } from "vuelidate";
import { required, email, numeric, minValue } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber},
  mixins: [validationMixin],
  validations: {
        quotationsObj: {
            vendorinfo:{required},
            NoQuot: { required },
            tglQuot: { required },
            NoReply: { required },
            tglQuot: { required },
            // NoteQuot: { required },
            matauang: { required },
            kurs: { required },
        },
        quotLinesObj: {
            itemno: { required },
            qtySupply: { minValue:minValue(0.01), required },
            Price: { minValue:minValue(0.01), required },
            diskon: { numeric, required },
            // KenaPPN: { required },
        },
        rfqEmail: {
            recepient: { email }
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        showDelConfirm:false,
        showList:true,
        horizontal:true,
        lkuVendorShow:false,
        isLoading:false,
        showReport:false,
        reportUrl: null,        
        tarifPPN: this.$store.state.user.tarifPPN || 11,
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        model:{nomor:'',tanggal:'', uraian:'', requisition:'', matauang: this.$store.state.user.matauang},
        quotations: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "vendor_name",
                    label: "Vendor/Supplier",
                },
                {
                    key: "NoQuot",
                    label: "Quotation Number",
                    thStyle: "width:150px",
                },
                {
                    key: "tglQuot",
                    label: "Quotation Date",
                    thStyle: "width:100px",
                },
                {
                    key: "NoReply",
                    label: "Version#",
                    thStyle: "width:60px",
                },
                {
                    key: "vendor_phone",
                    label: "Phone/Fax",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:250px",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        quotationsObj:{idTenderQuot:'',NoQuot:'',tglQuot:'',NoReply:1, NoteQuot:'', KenaPPN:1},
        quotLines: {
            items: [
                // {reqdtlkey:'reqdtlkey1', partnumber:'icode001',jasa:'0', itemname:'master item#1', description:'deskripsi item1'},
                //     {reqdtlkey:'reqdtlkey2', partnumber:'icode002',jasa:'0', itemname:'master item#2', description:'deskripsi item2'}
                ],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "itemname",
                    label: "Master Item",
                    thStyle: "width:240px",
                },
                {
                    key: "spekdetail",
                    label: "Specification/Description",
                    thStyle: "width:240px",
                },
                {
                    key: "qtyReady",
                    label: "Qty. Ready",
                    thStyle: "width:90px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "qtyIndent",
                    label: "Qty. Indent",
                    thStyle: "width:90px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "LamaHari",
                    label: "Delivery Time",
                    thStyle: "width:150px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "Price",
                    label: "Unit price",
                    thStyle: "width:110px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "diskon",
                    label: "Disount",
                    thStyle: "width:80px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "othercost",
                    label: "Other Cost",
                    thStyle: "width:90px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "KenaPPN",
                    label: "VAT(PPN)",
                    thStyle: "width:80px",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    key: "TermTxt",
                    label: "Term of Payment",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    key: "Warranty",
                    label: "Warranty",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 20,
            total: 0,
        },
        defaultDeliveryDays:30,
        defaultWarantyDays:30,
        defaultTermsDays:30,
        quotLinesObj:{itemno:'', description:'', qtySupply:0, qtyReady:0, qtyIndent:0, quantity:0, unitzise:'', Price:0, othercost:0, diskon:0, nilai:0, nilainett:0, dppnlain:100, ppn:11,pasalpph:'', KenaPPN:1},
        rfqEmail: {recepient:''}
    };
},
  computed: {
    invalidLines() {
      this.$v.quotLinesObj.$touch();
      return this.$v.quotLinesObj.$invalid;
    },
    invalidQuotationsObj() {
      this.$v.quotationsObj.$touch();
      return this.$v.quotationsObj.$invalid;
    },
    invalidEmail() {
      this.$v.rfqEmail.$touch();
      return this.$v.rfqEmail.$invalid;
    },
  },
  created: async function(){
    if (this.$route.params.idTender)  {
          toastr.info('Loading Detail Tendering Step#3, please wait')
          try {
            this.isLoading=true;
                const [currency,data] = await Promise.all([await proctender.currency(),await proctender.detailStep3(this.$route.params)]) ;
            this.isLoading=false;
                this.currency = currency;
            
                const row = data[0][0];
                // console.log('row',row)
                // this.saveEnabled=(row.send2wf === 0);
                row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
                for (var key in row) {
                    this.model[key] = row[key];
                }
                // console.log('row',data[1])
                this.quotations.items = data[1];
                // this.quotations.total=this.quotations.items.length;

                // this.quotLines.items=data[2]

                toastr.clear;

          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    } else {
        router.push({name : "procurement.tendering"});
    }
  },
  methods: {
    rowClicked(record, index) {
      if (this.quotations.selected.idTenderVendor == record.idTenderVendor) {
          this.editQuotation(record);
      } else {
        if ((this.quotations.selected) && (this.quotations.selected._rowVariant)) {
            delete this.quotations.selected._rowVariant;
        }
        this.quotations.selected = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    deleteConfirm(data) {
          this.showDelConfirm = true;
    },
    deleteData: async function() {
      await proctender.remove(this.quotations.selected);
      this.refresh();
    },
    printRfq: async function(obj) {
      if (obj.idTenderVendor) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await proctender.printRfq(obj);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    emailRfq: async function(obj) {
      if (obj) {
          this.isLoading=true;
          try {
                        // console.log('obj, ', obj);
              const hasilcheck = await proctender.emailRfqCheck(obj);
              if (hasilcheck.contact_email){
                  const arrEmail=hasilcheck.contact_email.split(',');
                  let allValid=true;
                  for (let index = 0; index < arrEmail.length; index++) {
                      this.rfqEmail.recepient=arrEmail[index];
                      if (this.invalidEmail) {
                            allValid=false;
                            toastr.error('Invalid Email Address.', "RFQ Mailing Error");
                      }
                  }
                  if (allValid==true) {
                    await proctender.emailRfq(obj);
                  } else {
                        toastr.warn('Please Edit Vendor Contact/EMAIL, before doing RFQ Mailing');
                  }
                this.isLoading=false;
              } else {
                this.isLoading=false;
                    toastr.warn('Please Edit Vendor Contact/EMAIL, before doing RFQ Mailing');
                    setTimeout(() => {
                        // let routeData = router.resolve({path: `vendor-supplier-form/${obj.idVendor}`});
                        // router.push({name :'procurement.vendorfrm', params: { vendor_id: obj.idVendor}});
                        let routeData = router.resolve({name :'procurement.vendorfrm', params: { vendor_id: obj.idVendor}});
                        window.open(routeData.href, '_blank');                        
                    }, 100);
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },

    editQuotation : async function (obj) {
        // console.log('obj ==>',obj)
        toastr.info('Loading Quotation lines');
        var dataVdrDtl = await proctender.tenderStep3VendorDetail(obj)
        // console.log('dataVdrDtl ==>',dataVdrDtl)
        this.quotLines.items=dataVdrDtl[1]
        this.quotLines.total=this.quotLines.items.length;

        this.showList=false;
        this.quotations.selected = obj;
        // for (var key in this.quotationsObj) {
        //     this.quotationsObj[key] = '';
        // }
        for (var key in obj) {
            this.quotationsObj[key] = obj[key];
        }
        for (var key in obj) {
            this.model[key] = obj[key];
        }
        this.model.tanggal = obj.tanggal ? moment(obj.tanggal).format('YYYY-MM-DD') : '';
        this.quotationsObj.tglQuot= (this.quotationsObj.tglQuot) ? moment(this.quotationsObj.tglQuot).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        this.quotationsObj.NoReply = this.quotationsObj.NoReply || 1;
        this.quotationsObj.matauang=dataVdrDtl[1][0]['matauang'] || this.uanguser;
        this.quotationsObj.kurs=dataVdrDtl[1][0]['kurs'] || 1;
        this.quotationsObj.NoteQuot =''
        this.$v.quotationsObj.$reset();
        
    },
    
    delQuotation: function (index) {
        if (index > -1) {
            const quotationsObj= this.quotations.items[index];
            const newLines = this.quotations.items.reduce((newArr, item) => {
                        if (item.requestkey !== quotationsObj.requestkey) {
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
            this.requestItem.items=newLines;
            this.quotations.items.splice(index, 1);
        }
    },
    saveQuotation: async function () {
        if (this.invalidQuotationsObj) {
            console.log('validation : ', this.$v.quotationsObj);
            // console.log('model obj : ',this.quotationsObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                    const row = this.quotationsObj;
                    const lines = this.quotLines.items.reduce((newArr, item) => {
                        if (((item.qtyReady || 0) + (item.qtyIndent|| 0)) >0) {
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    row.quotLines = lines;
                    const result = await proctender.saveQuotationStep3of4(row);
                    var {status}= result;
                    if(status==200){
                        if (row.quotLines.length==0) {
                            this.quotationsObj.NoReply = '';
                            this.quotationsObj.NoQuot =  '';
                            this.quotationsObj.tglQuot =  '';
                            this.quotationsObj.NoteQuot = '';

                        } 
                        var idxQuotationItm = this.quotations.items.findIndex(x=>x.idTenderVendor===row.idTenderVendor)
                        for (const key in this.quotationsObj) {
                            this.quotations.items[idxQuotationItm][key]=this.quotationsObj[key]                                                    
                        }
                        toastr.success("Complete successfully", "Save Order");
                        this.showList=true;
                        for (const key in this.quotationsObj) {
                            this.quotationsObj[key]='';                                                    
                        }
                    }
                    
                    
                    // this.model.idTender = this.model.idTender || '';
                    // this.model.nomor = this.model.nomor || '';
                    // const row = {};
                    // for (var key in this.model) {
                    //     row[key] = this.model[key];
                    // }
                    // row.terms = this.model.terms;
                    // row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    // row.lines = this.quotations.items;
                    // row.requestItems = this.requestItem.items.reduce((newArr, item) => {
                    //     if (item.selected) {
                    //         newArr.push(item);
                    //     }
                    //     return newArr;
                    // }, []);
                    // console.log('row',row)
                    // if ((row.lines.length>0) && (row.requestItems.length>0)) {
                    //     console.log('row',row)
                    //     // await proctender.insert(row);
                    //     // toastr.success("Complete successfully", "Save Order");
                    //     // this.nextStep();
                    // } else {
                    //     toastr.error('Please fill at least 1(one) Request Order and one Requested Item', 'ERROR MESSAGE');
                    // }
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Order Error");                
            }

        }
    },
    editOrdLines : function (obj,callback) {
        // console.log('editOrdLines obj',obj)

        this.quotLines.selected = obj;
        // for (var key in this.quotLinesObj) {
        //     this.quotLinesObj[key] = '';
        // }
        this.quotLinesObj.itemno='';
        this.quotLinesObj.itemname='';
        this.quotLinesObj.description='';
        this.quotLinesObj.qtyReady=0;
        this.quotLinesObj.qtyIndent=0;
        this.quotLinesObj.quantity=0
        this.quotLinesObj.unitzise=0
        this.quotLinesObj.Price=0
        this.quotLinesObj.othercost=0;
        this.quotLinesObj.diskon=0;
        this.quotLinesObj.nilai=0;
        this.quotLinesObj.nilainett=0;
        this.quotLinesObj.KenaPPN= this.quotLinesObj.KenaPPN || 0;
        this.quotationsObj.ppn = this.tarifPPN;
        // this.quotLinesObj.dppnlain:100, ppn:10,pasalpph:''},

        for (var key in obj) {
            this.quotLinesObj[key] = obj[key];
        }
        this.quotLinesObj.LamaHari=this.quotLinesObj.LamaHari||this.defaultDeliveryDays;
        this.quotLinesObj.Warranty=this.quotLinesObj.Warranty||this.defaultWarantyDays;
        this.quotLinesObj.Term=this.quotLinesObj.Term||this.defaultTermsDays;
        this.quotLinesObj.qtyReady= obj.qtyReady || this.quotLinesObj.QtyRequest;
        this.quotLinesObj.qtyIndent= obj.qtyIndent || 0;
        this.quotLinesObj.qtySupply= parseFloat(this.quotLinesObj.qtyReady)+parseFloat(this.quotLinesObj.qtyIndent);
        this.$v.quotLinesObj.$reset();

        // console.log('quotLinesObj obj',this.quotLinesObj)
        callback();
    },
    delOrdLines: function (index) {
        if (index > -1) {
            // this.quotLines.items.splice(index, 1);
            const posisi = (this.quotLines.page-1)*this.quotLines.limit;
            this.quotLines.items.splice(posisi+index, 1);
        }
        this.quotLines.total=this.quotLines.items.length;
    },
    saveOrdLines: async function (callback) {
        this.calcPrice();
        if (this.invalidLines) {
            console.log('validation : ', this.$v.quotLinesObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            let datadim=this.quotLinesObj;
            try {
                for (var key in this.quotLinesObj) {
                    this.quotLines.selected[key] = this.quotLinesObj[key];
                }
                this.quotLines.selected._showDetails=false;
                if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },

    backStep(){
        console.log('back step')
      // update status=2 to PREVIOUS STEPS
      // hapus semua quotation yang pernah diinput
    //   router.push({name :`procurement.tenderingfrm${this.mode.idstatus}`, params: { idTender: this.model.idTender}});              
      router.push({name :`procurement.tenderingfrm2`, params: { idTender: this.model.idTender}});              
    },
    nextStep: async function(){
        // const data = await proctender.detail(this.model);  
        // if (data[1].length>0) {
            // update field status=4 to NEXT STEPS
            // router.push({name :`procurement.tenderingfrm${this.mode.idstatus}`, params: { idTender: this.model.idTender}});              
            router.push({name :`procurement.tenderingfrm4`, params: { idTender: this.model.idTender}});              
        // } else {
        //     toastr.error('Please fill at least 1(one) Quotation Received, then click Save', 'ERROR MESSAGE');
        // }
    },
    
    closeFrm(){
      this.showList=true;
    },    

    close(){
    //   if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.tenderingfrm3')) {
    //     router.push({name:this.$store.state.prevRoute.name});
    //   } else {
      router.push({name : "procurement.tendering"});
    //   }
    },
    calcPrice : function () {
        // this.quotLinesObj.qtySupply=(this.quotLinesObj.qtyReady||0)+(this.quotLinesObj.qtyIndent||0);
        this.quotLinesObj.qtySupply= parseFloat(this.quotLinesObj.qtyReady || 0)+parseFloat(this.quotLinesObj.qtyIndent || 0);
        this.quotLinesObj.disc=this.quotLinesObj.disc||0;
        this.quotLinesObj.nilai = parseFloat(this.quotLinesObj.qtySupply) * parseFloat(this.quotLinesObj.Price);
        if (this.quotLinesObj.disc > 0) {
            this.quotLinesObj.diskon = this.quotLinesObj.disc * this.quotLinesObj.nilai / 100.0;
        };
        // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
        this.calcTaxes();
    },
    calcDiscValue : function () {
        this.quotLinesObj.diskon = parseFloat(this.quotLinesObj.disc) * parseFloat(this.quotLinesObj.nilai) / 100.0;
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.quotLinesObj.nilainett = parseFloat(this.quotLinesObj.nilai) - parseFloat(this.quotLinesObj.diskon || 0);
        this.quotLinesObj.dpp = parseFloat(this.quotLinesObj.nilai) * parseFloat(this.quotLinesObj.dppnlain) / 100;
        this.quotLinesObj.kenappn = true;
        if ((this.quotLinesObj.ppn || 0) == 0 ) {
            this.quotLinesObj.kenappn = false;
            this.quotLinesObj.dpp = 0;
            // this.quotLinesObj.ppn = 0;
        }
        // if (this.model.grossup == 1)
        //     this.quotLinesObj.dpp = this.quotLinesObj.dpp * (100 / (100 - this.quotLinesObj.pph));

        this.quotLinesObj.nilaippn = parseFloat(this.quotLinesObj.ppn) / 100 * this.quotLinesObj.dpp;
        this.quotLinesObj.nilaidue = this.quotLinesObj.nilainett + this.quotLinesObj.nilaippn;
    },

  }
};
</script>
